// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wishiwashi_school: PokeData = {
  "id": 10127,
  "name": "wishiwashi-school",
  "height": 82,
  "weight": 786,
  "base_experience": 217,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "take-down",
    "double-edge",
    "growl",
    "water-gun",
    "hydro-pump",
    "feint-attack",
    "beat-up",
    "uproar",
    "helping-hand",
    "endeavor",
    "dive",
    "brine",
    "aqua-ring",
    "aqua-tail",
    "soak",
    "tearful-look"
  ],
  "moves": [
    "growl",
    "hydro-pump",
    "brine",
    "aqua-tail",
    "life-dew",
    "bubble-beam",
    "whirlpool",
    "aqua-cutter",
    "water-spout",
    "rain-dance",
    "aqua-jet",
    "liquidation",
    "bubble"
  ],
  "evolution_chain": {
    "id": 384,
    "item": null,
    "species": [
      {
        "name": "wishiwashi",
        "order": 746,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 137,
    "speed": 46,
    "ability_power": 216
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
